import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();


  const login = async (e) => {
    e.preventDefault(); // prevent page reload
    try {
      await api.post('/auth/login',
         { username, password },
         {
        headers: {
          'Content-Type': 'application/json'
        }
      }
        );
      setError('');
      onLogin(); // trigger dashboard or redirect
       navigate('/dashboard');
    } catch (err) {
      if (err.response?.status === 401) {
        setError('Invalid username or password');
      } else {
        setError('Something went wrong. Please try again.');
      }
    }
  };

  return (
    <div className="bg-gray-100 h-screen w-screen">
      <div className="flex flex-col md:flex-row h-full w-full">

        {/* Left Side: Image */}
        <div className="md:w-1/2 w-full h-full relative">
          <img
            src="/loginpic.jpg"
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>

        {/* Right Side: Login Form */}
        <div className="md:w-1/2 w-full flex items-center justify-center p-8 bg-white">
          <div className="w-full max-w-md">
            {/* Logo */}
            <div className="mb-6">
              <img src="/Logo.png" alt="Logo" className="h-20 w-70" />
            </div>

            {/* Headings */}
            <h2 className="text-2xl font-bold mb-2">Login to your Account</h2>
            <p className="text-gray-600 mb-6">See what is going on</p>

            {/* Form */}
            <form onSubmit={login}>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Username</label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md focus:ring focus:ring-lime-300"
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md focus:ring focus:ring-lime-300"
                />
              </div>

              <div className="flex items-center justify-between mb-6">
                <label className="flex items-center text-sm text-gray-700">
                  <input type="checkbox" className="mr-2" />
                  Remember me
                </label>
                <a href="https://api.whatsapp.com/send/?phone=%2B263774399906&text&type=phone_number&app_absent=0" target='_blank' rel='noreferrer' className="text-sm text-lime-600 hover:underline">
                  Forgot Password?
                </a>
              </div>

              <button
                type="submit"
                className="w-full bg-lime-600 text-white py-2 rounded-md hover:bg-lime-700 transition"
              >
                Login
              </button>

              {error && (
                <p className="mt-4 text-red-600 text-sm text-center">{error}</p>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}